import { getAnonId } from './CookieService';

class MenuService {
    constructor() {
        this.baseUrl = process.env.REACT_APP_API_URL;
    }

    async getMyOrders() {
        try {
            console.log(`${this.baseUrl}/Orders/Anon/${getAnonId()}`);
            const response = await fetch(`${this.baseUrl}/Orders/Anon/${getAnonId()}`);
            const data = await response.json();
            const sortedData = data.sort((a, b) => b.id - a.id);
            return sortedData;
        } catch (error) {
            console.error('Error fetching orders:', error);
            return [];
        }
    }

    async getReviews() {
        try {
            // Retrieve the reviews
            const response = await fetch(`${this.baseUrl}/Reviews/${getAnonId()}`);
            const data = await response.json();
            console.log('Retrieved review:', data);
            return data;
        } catch (error) {
            console.error('Error retrieving reviews:', error);
            return [];
        }
    };

    async saveReviews(newReviews) {
        // save reviews to backend
        fetch(`${this.baseUrl}/Reviews`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ reviews: newReviews, id: getAnonId() })
        });
    }

    async checkShopStatus() {
        try {
            const response = await fetch(`${this.baseUrl}/ApplicationParams/shopOpen`);
            const data = await response.json();
            if (data.value === 'True') {
                console.log('Shop is open');
                return true;
            } else {
                console.log('Shop is closed');
                return false;
            }
        } catch (error) {
            console.error('Error fetching shop status:', error);
            return false;
        }
    }

    async getMenuItems() {
        try {
            const response = await fetch(`${this.baseUrl}/Menu`);
            const data = await response.json();

            const parsedData = data.map(product => ({
                ...product,
                price: parseFloat(product.price)
            }));
            return parsedData.sort((a, b) => a.productNumber - b.productNumber);
        } catch (error) {
            console.error('Error fetching shop status:', error);
            return [];
        }
    }

    async saveOrder(order) {
        order.anonId = getAnonId();
        order.orderDate = new Date().toISOString();
        try {
            const response = await fetch(`${this.baseUrl}/Orders`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(order)
            });
            if (response.ok) {
                var data = await response.json();
                console.log(data);
                return data;
            } else {
                console.error('Error saving order:', response);
                return null;
            }
        } catch (error) {
            console.error('Error saving order:', error);
            return null;
        }
    }
}

export default MenuService;